import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../core/service'

export const getTopByIndustry = createAsyncThunk(
  'portfolio/summary/getTopByIndustry',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getTopByIndustry(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getTopByProvince = createAsyncThunk(
  'portfolio/summary/getTopByProvince',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getTopByProvince(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getBussinessSize = createAsyncThunk(
  'portfolio/summary/getBussinessSize',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getBussinessSize(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getYearOfOperation = createAsyncThunk(
  'portfolio/summary/getYearOfOperation',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getYearOfOperation(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportPortfolioSegment = createAsyncThunk(
  'portfolio/summary/exportPortfolioSegment',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.exportPortfolioSegment(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
